<!-- Created by anish on 19/06/28. -->

<template>
  <div>
    <!--<wxc-cell
      :extraContent="extraContent"
      :extra-content-style="selectedItemStyle"
      :has-arrow="true"
      :has-margin="false"
      :has-bottom-border="false"
      :has-vertical-indent="false"
      :cell-style="cellStyle"
      :arrow-icon="arrowIcon"
      @wxcCellClicked="showOrHideDropdownOptions">
      <weex-text >slot="title" :style="titleStyle">{{title}}</weex-text>
    </wxc-cell>
    <div class="bottom-border" v-if="!dropdownOptionsShown"></div>
    <scroller class="scroller" :style="dropDownOptionStyle"
              v-if="dropdownOptionsShown && !disabled">
      <wxc-radio
        :list="updateList"
        :has-bottom-border="true"
        :config="optionConfig"
        @wxcRadioListChecked="onDropdownOptionSelected"
      ></wxc-radio>
    </scroller>-->

    <v-select
        :solo="!showBottomBorder"
        :flat="!showBottomBorder"
        :hide-details="hideAdditionalDetails"
      v-model="vModel"
      :items="updateList"
      :placeholder="defaultItem"
      :readonly="disabled"
      @input="onDropdownOptionSelectedNew">
      <div v-if="title" slot="label"><span :style="titleStyle" v-html="title"></span></div>
      <div v-if="selectedOptionTitle"
           slot="selection"><span :style="selectedItemStyle" v-html="selectedOptionTitle"></span>
      </div>
      <div slot="prepend-item">
        <input v-if="enableSearch" type="text" class="search_select" placeholder="Search here..." v-model="searchedQuery"/>
      </div>
    </v-select>

  </div>
</template>

<style scoped>

.bottom-border {
  margin-left: 20px;
  border-bottom-width: 1px;
  border-bottom-style: solid;
  border-bottom-color: gray;
}

.scroller {
  margin-left: 18px;
}

.search_select{
  height: 35px;
  border-bottom: 1px solid gray;
  width: 100%;
  padding-left: 10px;
}

.search_select:focus{
  outline: none;
}

</style>

<script>
import WxcCell from '../wxc-cell';
import WxcRadio from '../wxc-radio';

export default {
  components: { WxcCell, WxcRadio },
  props: {
    title: {
      type: String,
      default: ""
    },
    list: {
      type: Array,
      default: []
    },

    disabled: {
      type: Boolean,
      default: false
    },

    selectItem: {
      type: String,
      default: ""
    },

    defaultItem: {
      type: String,
      default: ""
    },

    config: {
      type: Object,
      default: () => ({})
    },

    enableSearch: {
      type: Boolean,
      default: true
    },

    showBottomBorder: {
      type: Boolean,
      default: true
    },

    hideAdditionalDetails: {
      type: Boolean,
      default: false
    },

  },
  data: () => ({
    selectedItem: "",
    selectedIndex: -1,
    dropdownOptionsShown: false,
    vModel: null,
    selectedOptionTitle: null,
    searchedQuery: null
  }),
  computed: {

    updateList() {
      const { list } = this;
      const updateList = [];
      list && list.forEach((item, i) => {
        const itemToPush = {};
        if (item) {
          if (item.title) {
            itemToPush.text = item.title;
          } else {
            itemToPush.text = item;
          }

          if (item.value) {
            itemToPush.value = item.value;
          } else {
            itemToPush.value = item;
          }
        }
        if(this.enableSearch && this.searchedQuery){
            if(itemToPush.text.toUpperCase().includes(this.searchedQuery.toUpperCase()) 
              || itemToPush.value.toUpperCase().includes(this.searchedQuery.toUpperCase())){
                updateList.push(itemToPush);
              }
        }else{
          updateList.push(itemToPush);
        }
        
      });
      return updateList;
    },

    optionConfig() {
      if (this.config.radioItemStyle) {
        return { 'hasVerticalIndent': false, 'radioItemStyle': this.config.radioItemStyle }
      } else {
        return { 'hasVerticalIndent': false }
      }
    },
    arrowIcon() {
      if (this.dropdownOptionsShown) {
        if (this.config.pullUpIcon) {
          return this.config.pullUpIcon
        }
      } else {
        if (this.config.dropDownIcon) {
          return this.config.dropDownIcon
        }
      }
    },
    extraContent() {
      if (this.selectedItem) {
        return this.selectedItem;
      } else {
        return this.defaultItem;
      }
    },
    selectedItemStyle() {
      if (this.disabled && this.config.disabledItemStyle) {
        return this.config.disabledItemStyle;
      } else if (this.config.selectedItemStyle) {
        return this.config.selectedItemStyle;
      } else {
        return {}
      }
    },
    titleStyle() {
      if (this.config.titleStyle) {
        return this.config.titleStyle;
      } else {
        return {}
      }
    },
    cellStyle() {
      if (this.config.cellStyle) {
        return this.config.cellStyle;
      } else {
        return {}
      }
    },
    dropDownOptionStyle() {
      let height = '240px';
      if (this.list.length === 0) {
        height = '0px';
      } else if (this.list.length === 1) {
        height = '80px';
      } else if (this.list.length === 2) {
        height = '160px';
      }

      return { 'height': height };
    }
  },

  created() {
    if (this.vModel !== this.selectItem) {
        this.vModel = this.selectItem
        this.onDropdownOptionSelectedNew(this.vModel)
      }
  },

  watch: {
    list: function () {
      this.onDropdownOptionSelected({ 'index': -1, 'title': '', 'value': '' });
    },

    selectItem: function () {
      if (this.vModel !== this.selectItem) {
        this.vModel = this.selectItem
        this.onDropdownOptionSelectedNew(this.vModel)
      }

      /* let selected = false;
       this.updateList && this.updateList.forEach((item, i) => {
         if (item && item.title && item.title === this.selectItem) {
           this.onDropdownOptionSelected({ 'index': i, 'title': item.title, 'value': item.value });
           selected = true;
         }
       });
       if (!selected) {
         this.onDropdownOptionSelected({ 'index': -1, 'title': '', 'value': '' });
       }*/
    },
  },

  methods: {
    onDropdownOptionSelected(e) {
      this.selectedItem = e.title;
      this.dropdownOptionsShown = false;
      if (e.index !== this.selectedIndex) {
        this.selectedIndex = e.index;
        this.$emit('onItemSelected', { 'value': e.value, 'title': e.title })
      }
    },
    onDropdownOptionSelectedNew(e) {
      this.$emit('onItemSelected', { 'value': e, 'title': e })
      this.selectedOptionTitle = "";
      const options = this.list;
      options && options.forEach(option => {
        if (option && option.value === e && option.title) {
          this.selectedOptionTitle = option.title;
        }
      })
    },

    showOrHideDropdownOptions() {
      if (this.disabled) {
        this.dropdownOptionsShown = false;
      } else {
        this.dropdownOptionsShown = !this.dropdownOptionsShown;
      }
    },

  }
}
</script>
